import { useCallback, useRef, useState } from 'react';

const useFetchCaptchaToken = () => {
	const [isLoading, setIsLoading] = useState(true);
	const captchaRef = useRef(null);

	const fetchToken = useCallback(async () => {
		setIsLoading(true);
		try {
			const token = await captchaRef.current.executeAsync();
			captchaRef.current.reset();
			return token;
		} catch (err) {
			return null;
		} finally {
			setIsLoading(false);
		}
	}, []);

	return { fetchToken, isLoading, captchaRef };
};

export default useFetchCaptchaToken;
